<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
           <div  class="div-query-banner"  >
              <a-form-item label="受理状态">
                <j-dict-select-tag  v-model="queryParam.statusCode" placeholder="请输入选择受理状态"  dictCode="administration_feedback_status" ></j-dict-select-tag>
              </a-form-item>
              <a-form-item label="反馈类别">
                <j-dict-select-tag  v-model="queryParam.typeCode" placeholder="请输入选择反馈类别" dictCode="administration_feedback_type"  ></j-dict-select-tag>
              </a-form-item>
              <a-form-item  v-show="toggleSearchStatus" label="区域">
                <j-dict-select-tag  v-model="queryParam.areaCode" placeholder="请输入选择区域"  dictCode="administration_feedback_area" ></j-dict-select-tag>
              </a-form-item>
              <a-form-item  v-show="toggleSearchStatus" label="反馈项目">
                <j-dict-select-tag  v-model="queryParam.projectCode" placeholder="请输入选择反馈项目" dictCode="administration_feedback_project"  ></j-dict-select-tag>
              </a-form-item>
              <a-form-item  v-show="toggleSearchStatus" label="项目编号">
                <a-input   v-model="queryParam.number"    />
              </a-form-item>
              <a-form-item  v-show="toggleSearchStatus" label="提交人姓名">
                <a-input   v-model="queryParam.fbUserName"    />
              </a-form-item>
              <a-form-item  v-show="toggleSearchStatus" label="受理人姓名">
                <a-input   v-model="queryParam.dealUserName"    />
              </a-form-item>
              
              <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" class="toggle-a">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </div>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('金牌GIS行政管理-意见反馈')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a  type="primary" @click="handleSeeMoreClick(record)">查看更多</a>
        </span>
      </a-table>
    </div>

    <feedback-content-detail-modal @freshen="loadData()" ref="feedbackContentDetailModal" @ok="modalFormOk"></feedback-content-detail-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import FeedbackContentDetailModal from './modules/FeedbackContentDetailModal'
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "FeedbackContentList",
    mixins:[JeecgListMixin],
    components: {
      FeedbackContentDetailModal,JInput
    },
    data () {
      return {
        description: '金牌GIS行政管理-意见反馈管理页面',
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:"50px",
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '查看详情',
            dataIndex: 'action',
            align:"center",
            width:"120px",
            scopedSlots: { customRender: 'action' }
          },
          {
            title:'编号',
            align:"center",
            width:"140px",
            dataIndex: 'number'
          },
          {
            title:'姓名',
            align:"center",
            dataIndex: 'fbUserName',
            width:"110px",
          },
          {
            title:'区域',
            align:"center",
            width:"80px",
            dataIndex: 'areaCode_dictText'
          },
          {
            title:'反馈类别',
            align:"center",
            width:"80px",
            dataIndex: 'typeCode'
          },
          {
            title:'反馈项目',
            align:"center",
            width:"80px",
            dataIndex: 'projectCode'
          },
          {
            title:'反馈日期',
            align:"center",
            width:"160px",
            dataIndex: 'createTime'
          },
          {
            title:'反馈内容',
            align:"center",
            dataIndex: 'fbContent',
            ellipsis:true
          },
          {
            title:'受理状态',
            align:"center",
            width:"80px",
            dataIndex: 'statusCode'
          },
          {
            title:'处理内容',
            align:"center",
            dataIndex: 'dealContent',
            ellipsis:true
          },
        ],
        url: {
          list: "/administration/base/feedbackContent/getList",
          delete: "/administration/base/feedbackContent/delete",
          deleteBatch: "/administration/base/feedbackContent/deleteBatch",
          exportXlsUrl: "/administration/base/feedbackContent/exportXls",
          importExcelUrl: "administration/base/feedbackContent/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      handleSeeMoreClick(record){
        this.$refs.feedbackContentDetailModal.open(record)
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    & >*:nth-child(n){
      width:300px;
      
    }
    &>*:nth-child(n){
      margin-left: 15px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
    .toggle-a{
      margin-top: 9px;
      margin-left: 8px;
    }
  }
</style>